import PermissionActiveToggle from './PermissionActiveToggle';

export default PermissionActiveToggle;
